import Checkbox from '@mui/material/Checkbox'; 
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'; 
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked'; 
import { useTranslation } from 'react-i18next';
import {
  RadioSectionWrapper,
  RadioItem,
  RadioLabel,
  RadioList,
  RadioTitle,
} from './stylex';

interface RadioSectionProps {
  requirementUppercase?: boolean;
  requirementLowercase?: boolean;
  requirementNumber?: boolean;
  requirementSpecialChar?: boolean;
  requirementMinLength?: boolean;
}

const RadioSection = ({
  requirementUppercase,
  requirementLowercase,
  requirementNumber,
  requirementSpecialChar,
  requirementMinLength
}: RadioSectionProps) => {
  const { t } = useTranslation();

  const checkboxStyle = {
    color: '#9081F6',
    padding: 0,
    marginRight: '8px', 
  };

  return (
    <RadioSectionWrapper>
      <RadioTitle>{t('Signup.passwordRequirementsTitle')}</RadioTitle>
      <RadioList>
        <RadioItem>
          <Checkbox
            checked={requirementUppercase}
            icon={<RadioButtonUncheckedIcon />} 
            checkedIcon={<RadioButtonCheckedIcon />} 
            style={checkboxStyle}
          />
          <RadioLabel>{t('Signup.requirementUppercase')}</RadioLabel>
        </RadioItem>
        <RadioItem>
          <Checkbox
            checked={requirementLowercase}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<RadioButtonCheckedIcon />}
            style={checkboxStyle}
          />
          <RadioLabel>{t('Signup.requirementLowercase')}</RadioLabel>
        </RadioItem>
        <RadioItem>
          <Checkbox
            checked={requirementNumber}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<RadioButtonCheckedIcon />}
            style={checkboxStyle}
          />
          <RadioLabel>{t('Signup.requirementNumber')}</RadioLabel>
        </RadioItem>
        <RadioItem>
          <Checkbox
            checked={requirementSpecialChar}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<RadioButtonCheckedIcon />}
            style={checkboxStyle}
          />
          <RadioLabel>{t('Signup.requirementSpecialChar')}</RadioLabel>
        </RadioItem>
        <RadioItem>
          <Checkbox
            checked={requirementMinLength}
            icon={<RadioButtonUncheckedIcon />}
            checkedIcon={<RadioButtonCheckedIcon />}
            style={checkboxStyle}
          />
          <RadioLabel>{t('Signup.requirementMinLength')}</RadioLabel>
        </RadioItem>
      </RadioList>
    </RadioSectionWrapper>
  );
};

export default RadioSection;
